import React, { useState, useEffect } from "react";
import { 
    Grid, 
    GridColumn, 
    Tab, 
    TabPane,
    TableRow,
    TableHeaderCell,
    TableHeader,
    TableFooter,
    TableCell,
    TableBody,
    Table,
    Input,
    Modal,
    Button
} from "semantic-ui-react";
import {useForm, Controller} from "react-hook-form"
import axios from "axios";

const IntegrationTable = (projects) => {
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const {
        register,
        control,
        handleSubmit,
        reset
    } = useForm()

    console.log(projects)

    // Состояние для пагинации
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Количество записей на странице

        // Состояние для редактирования
    const [editModalOpen, setEditModalOpen] = useState(false); // Открытие модального окна
    const [currentRowData, setCurrentRowData] = useState(null); // Данные текущей строки
    const [editedData, setEditedData] = useState({}); // Данные, которые редактируем

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(process.env.REACT_APP_API_requests + '?request=websiteDataIntegrations', {})
                setData(response.data);
            } catch (error) {
                console.error('ошибка ', error);
            }
        }
        fetchData();
    }, []);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Сбросить на первую страницу при изменении поиска
    };

    // Фильтрация данных по поисковому запросу перед пагинацией
    const filteredData = data.filter(item =>
        item.id.toString().includes(searchTerm) ||
        item.integration_id.toString().includes(searchTerm)
    );

    // Определяем данные для текущей страницы после фильтрации
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    // Функции для смены страниц
    const nextPage = () => {
        if (currentPage < Math.ceil(filteredData.length / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Открыть модальное окно для редактирования
    const openEditModal = (rowData) => {
        setCurrentRowData(rowData);
        setEditedData(rowData); // Инициализируем данные для редактирования
        setEditModalOpen(true);
    };

    // Закрытие модального окна
    const closeModal = () => {
        setEditModalOpen(false);
        setCurrentRowData(null);
    };

    // Отправка данных на вебхук при сохранении
    const handleSave = async () => {
        try {
            await axios.post(process.env.REACT_APP_API_edit_url + "?request=editIntegrationsWebsites", editedData);
            setData(prevData =>
                prevData.map(item => item.id === currentRowData.id ? editedData : item)
            );
            closeModal();
        } catch (error) {
            console.error('Ошибка отправки данных на вебхук: ', error);
        }
    };

    return (
        <div>
            <Input
                icon='search'
                placeholder='Search...'
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ marginBottom: '10px' }}
            />
            <Table celled>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Integration ID</TableHeaderCell>
                        <TableHeaderCell>URL</TableHeaderCell>
                        <TableHeaderCell>Duplicates Filter</TableHeaderCell>
                        <TableHeaderCell>Source Details</TableHeaderCell>
                        <TableHeaderCell>Project</TableHeaderCell>
                        <TableHeaderCell>Language</TableHeaderCell>
                        <TableHeaderCell>Hidden Source</TableHeaderCell>
                        <TableHeaderCell>Marker</TableHeaderCell>
                        <TableHeaderCell>Responsible</TableHeaderCell>
                        <TableHeaderCell>Edit</TableHeaderCell>
                    </TableRow>
                </TableHeader>

                <TableBody>
                    {currentItems.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>{item.id}</TableCell>
                            <TableCell>{item.integration_id}</TableCell>
                            <TableCell>{item.url}</TableCell>
                            <TableCell>{item.duplicates_filter}</TableCell>
                            <TableCell>{item.source_details}</TableCell>
                            <TableCell>{item.ad_project ? "test" : "NULL"}</TableCell>
                            <TableCell>{item.ad_language ? "test" : "NULL"}</TableCell>
                            <TableCell>{item.hidden_source}</TableCell>
                            <TableCell>{item.marker}</TableCell>
                            <TableCell>{item.responsible == 1 ? "AX CAPITAL" : "NULL"}</TableCell>
                            <TableCell>
                                <Button onClick={() => openEditModal(item)}>Edit</Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>

                <TableFooter>
                    <TableRow>
                        <TableHeaderCell colSpan='10'>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button onClick={prevPage} disabled={currentPage === 1}>
                                    Previous
                                </Button>
                                <span>Page {currentPage} of {Math.ceil(filteredData.length / itemsPerPage)}</span>
                                <Button onClick={nextPage} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
                                    Next
                                </Button>
                            </div>
                        </TableHeaderCell>
                    </TableRow>
                </TableFooter>
            </Table>

            {/* Модальное окно для редактирования */}
            <Modal open={editModalOpen} onClose={closeModal}>
            <Modal.Header>Edit Data</Modal.Header>
            <Modal.Content>
                <Grid.Row>
                    <Grid.Column>
                        <Controller
                            name='code'
                            defaultValue=""
                            control={control}
                            render={({field}) => <Input type='text' placeholder='Insert...' {...field}/>}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Modal.Content>
                <Modal.Actions>
                    <Button onClick={closeModal}>Cancel</Button>
                    <Button primary onClick={handleSave}>Save</Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
};



export default function WebsitesData(projectsProps){

    const panes = [
        { menuItem: 'Websites Integrations', render: () => <TabPane><IntegrationTable projects={projectsProps} /></TabPane> },
    ];

    return(
        <>
            <div className="websites-dataTable">
                <Grid columns={1}>
                    <GridColumn>
                        <Tab panes={panes}/>
                    </GridColumn>
                </Grid>
            </div>
        </>
    );
}